// extracted by mini-css-extract-plugin
export default {"case_template_title":"TemplatePopup_case_template_title__jV4nM"};